import { DeleteOutlined, DeleteTwoTone, LockOutlined, LockTwoTone, UnlockOutlined, UnlockTwoTone } from "@ant-design/icons";
import { Button, Space } from "antd";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import Tooltip from "components/atoms/Tooltip";
import PageLayout from "components/molecules/PageLayout";
import AdminTenantOverview from "containers/AdminTenantOverview";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

const TenantOverviewPage = () => {
    const [tenant, setTenant] = useState<ITenant | null>(null);
    const tenantInstance = useRef<{
        disableTenant: () => void;
        enableTenant: () => void;
        deleteTenant: () => void;
    } | null>(null);
    const { tenantid } = useParams<{ tenantid: string }>();

    useEffect(() => {
        return () => {
            tenantInstance.current = null;
        };
    }, []);

    const onDisableTenantClick = () => {
        if (tenantInstance.current) {
            tenantInstance.current.disableTenant();
        }
    };

    const onEnableTenantClick = () => {
        if (tenantInstance.current) {
            tenantInstance.current.enableTenant();
        }
    };

    const onDeleteTenantClick = () => {
        if (tenantInstance.current) {
            tenantInstance.current.deleteTenant();
        }
    };

    return (
        <PageLayout
            key={`${tenantid}_tenant_overview_page`}
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => (
                <SegmentContainer>
                    <Segment shadow>
                        <AdminTenantOverview
                            instance={tenantInstance}
                            tenantId={tenantid}
                            setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                            onFetchTenant={setTenant}
                        ></AdminTenantOverview>
                    </Segment>
                </SegmentContainer>
            )}
            actions={
                <Space.Compact size="small">
                    <Tooltip title="Disable Tenant">
                        <Button
                            style={{ paddingRight: 18, paddingLeft: 18 }}
                            onClick={onDisableTenantClick}
                            icon={!tenant || !tenant.enabled ? <LockOutlined /> : <LockTwoTone />}
                            disabled={!tenant || !tenant.enabled}
                        />
                    </Tooltip>
                    <Tooltip title="Enable Tenant">
                        <Button
                            style={{ paddingRight: 18, paddingLeft: 18 }}
                            onClick={onEnableTenantClick}
                            icon={!tenant || tenant.enabled ? <UnlockOutlined /> : <UnlockTwoTone />}
                            disabled={!tenant || tenant.enabled}
                        />
                    </Tooltip>
                    <Tooltip title="Delete Tenant">
                        <Button
                            style={{ paddingRight: 18, paddingLeft: 18 }}
                            onClick={onDeleteTenantClick}
                            icon={!tenant || tenant.enabled ? <DeleteOutlined /> : <DeleteTwoTone />}
                            disabled={!tenant || tenant.enabled}
                        />
                    </Tooltip>
                </Space.Compact>
            }
            actionPlacement="right"
        />
    );
};

export default TenantOverviewPage;
